var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1e3a9b6e720214e2b0a330279ee0dc9a.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c1c687b31f24eb3678b6b3a8083b38e7.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    